import React from 'react';
import Logo from '../../images/logo-3.png'

const Features = (props) => {
    const FeatureArray = [
        {
            title: 'Financial Aid for Students',
            icon: 'flaticon-money-bag', // Represents financial support
            isImage: false,
        },
        {
            title: 'Academic Resources & Support',
            icon: 'flaticon-triangular-ruler', // Related to education/school tools
            isImage: false,
        },
        {
            title: 'Mentorship for Young Adult',
            icon: 'flaticon-user', // Represents people/mentorship
            isImage: false,
        },
        {
            title: 'Hope & Healing after A Life Transition',
            icon: 'flaticon-heart', // Represents compassion/support
            isImage: false,
        },
    ];

    return (
        <section className="feature-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="feature-grids">
                            {FeatureArray.map((features, fitem) => (
                                <div
                                    className="grid"
                                    key={fitem}
                                    style={{ maxWidth: '300px', height: '240px' }}
                                >
                                    {features.isImage ? (
                                        <img
                                            src={features.icon}
                                            alt={features.title}
                                            className="feature-icon"
                                        />
                                    ) : (
                                        <i className={`fi ${features.icon}`}></i>
                                    )}
                                    <h3>{features.title}</h3>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default Features;
